// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2CnQh","containerItemsCenter":"Skeleton_containerItemsCenter__wfFCm"};